Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.Filter
  possibleValues: []
  removable: true
  reappliable: true

  constructor: ({values}) ->
    @values = values

  getFilterType: ->
    throw new Error 'Not implemented'

  getValues: ->
    @values

  setValues: (values) =>
    @values = values

  getPossibleValues: ->
    @possibleValues

  isRemovable: ->
    @removable

  isReappliable: ->
    not @removable or @reappliable

  removeValue: (value) ->
    throw new Error 'Not implemented'

  hasValues: ->
    throw new Error 'Not implemented'

  toJSON: ->
    "#{@getFilterType()}": @_valuesToJSON()

  _valuesToJSON: ->
    throw new Error 'Not implemented'

  translatedFilterType: ->
    @getFilterType()

  removeFromCompositeFilter: (compositeFilter) =>
    filter = compositeFilter.filterWithType(@getFilterType())
    compositeFilter.removeFilter(filter)

  removeValueFromCompositeFilter: (compositeFilter, value) ->
    filter = compositeFilter.filterWithType(@getFilterType())
    compositeFilter.removeValue(filter, value)
